// extracted by mini-css-extract-plugin
export default {"ProductModal__picture":"gv80_GkqPHLGmDNN977H","ProductModal__image":"B3f2I7c1N6KpUHudpA6a"};